export default __webpack_public_path__ + "static/media/parade.812ad0d7.png";